/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import LetShop3 from "./card1";
import { useLocation } from "react-router-dom";
import PageError500 from "../../Components/PageError/PageError";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
const Card = () => {
  const translation = getTranslationData();
  const location = useLocation();
  const [showError, setShowError] = useState(false);
  const isLogin = sessionStorage.getItem("login");
  const pageError = {
    StatusCode: "401",
    ErrorName: translation?.errorName,
    ErrorDesription: translation?.errorDescription,
    url: "/",
    buttonText: translation?.backToHome,
  };
  const { arrayData } = location.state || {};
  useEffect(() => {
    !isLogin && setShowError(true);
  }, []);
  return (
    <div>
      {showError ? (
        <PageError500 pageError={pageError} />
      ) : (
        <LetShop3 arrayData={arrayData} />
      )}
    </div>
  );
};

export default Card;
